import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';

export const flattenCategories = (categories: CategoryHierarchy[], flattened: CategoryHierarchy[] = []): CategoryHierarchy[] => {
    for (const cat of categories) {
        flattened.push(cat);
        if (cat.Children) {
            flattenCategories(cat.Children, flattened);
        }
    }
    return flattened;
};

export const getCategoryParents = (
    currentCategory: CategoryHierarchy | undefined,
    categories: CategoryHierarchy[],
    parents: CategoryHierarchy[] = []
): CategoryHierarchy[] => {
    const parent = categories.filter(i => i.RecordId === currentCategory?.ParentCategory);
    parent && parents.push(parent[0]);
    if (parents.length) {
        const lastAdded = parents[-1];
        if (lastAdded?.ParentCategory) {
            getCategoryParents(lastAdded, categories, parents);
        }
    }
    return parents;
};

export const getAllProductsCategoryRecId = (categories: CategoryHierarchy[] = [], allProductsCategoryRootName: string) => {
    let found;

    found = categories.find(category => category.Name?.lastIndexOf(allProductsCategoryRootName, 0) === 0);
    if (!found) {
        found = categories.forEach(category => getAllProductsCategoryRecId(category.Children, allProductsCategoryRootName));
    } else {
        return found.RecordId;
    }

    return null;
};
